import { createCancellationReasonRequest } from "../../data/cancellationReasonApi";
import { validateCancellationReasonPayload } from "../validator/validateCancellationReasonPayload";

export async function createCancellationReasonUseCase(payload) {
  const error = validateCancellationReasonPayload(payload);

  if (error) {
    throw new Error(error);
  }

  return await createCancellationReasonRequest(payload);
}
